export default __webpack_public_path__ + "img/headerBG.a8fbcc63.png";